import { ActionApiService } from '../Services/action-api/action-api.service';
import { Layoutresolver } from '../Services/layout/layout-resolver';
import { StoreService } from '../Services/store';
import { AddressesService } from '../Services/addresses/Addresses';
import { ComponentDimensions } from '../components/utils/component-dimensions';
import { ModalService } from '../Services/modal-factory/modal-factory';
import { ModalHandlerService } from '../Services/modal-factory/modal-handler';
import { AccordionHelperService } from '../Services/accordion-helper/accordion-helper';
import { LinkExpirationServie } from '../Services/link-expiration/link-expiration';
import { ObservablesService } from '../Services/observables/observables';
import { SessionTimeoutService } from '../Services/session-timeout/session-timeout';
import { LoadTimeService } from '../Services/LoadTimeService/load-time-service';
import { InformationModalService } from '../Services/information-model-factory/information-model-factory';
import { ReportEventService } from '../Services/report-event/report-event.service';
import { ScrollEventHandlerService } from '../Services/scroll-event-handler/scroll-event-handler.service';
import { PagesDurationService } from './pages-duration/pages-duration.service';
import { SplunkAnalyticsService } from './splunk-analytics/splunk-analytics-service';
import { CarrierInformationService } from './carrier-information-service/carrier-information-service';
import { ChatbotService } from './chatbot-service/chatbot.service';

export const servicesArr = [
	SplunkAnalyticsService,
	ModalHandlerService,
	ActionApiService,
	Layoutresolver,
	StoreService,
	ComponentDimensions,
	AddressesService,
	ModalService,
	AccordionHelperService,
	LinkExpirationServie,
	ObservablesService,
	SessionTimeoutService,
	LoadTimeService,
	InformationModalService,
	ReportEventService,
	ScrollEventHandlerService,
	PagesDurationService,
	ChatbotService,
	CarrierInformationService,
];
